export default function inTemplateColumn() {
    return {
        restrict: 'E',
        scope: {
            field: '<',
            entry: '<',
            entity: '<'
        },
        link: function(scope) {
            // scope.field = scope.field();
            // scope.entry = scope.entry();
            // scope.entity = scope.entity();
        },
        template: '<span compile="field.getTemplateValue(entry)"></span>'
    };
}

inTemplateColumn.$inject = [];



// WEBPACK FOOTER //
// ./app/components/common/crud/column/inTemplateColumn.js